import LoginBloc from "../blocs/login/LoginBloc";
import LoginCoverBloc from "../blocs/login/LoginCoverBloc";

export default function LoginPage() {




    return (
        <section className="bg-glace p-y-xl">
            <div className="grid bloc-coadherent">
                <LoginCoverBloc/>
                <LoginBloc/>
            </div>
        </section>
    )

}